import { Component, inject, input } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { Screen } from '~core/models/screen.models';
import { ScreenCreationDialogComponent } from '../../modals/screen-creation-dialog/screen-creation-dialog.component';
import { ScreenService } from '~app/app/~shared/services/screen.service';
import { DeleteConfirmComponent } from '~app/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'screen-list-datatable',
  templateUrl: './screen-list-datatable.component.html',
  styleUrl: './screen-list-datatable.component.scss'
})
export class ScreenListDatatableComponent extends BaseComponent {
  private _dialogService = inject(DialogService);
  private _screenService = inject(ScreenService);
  private _resourceFacade = inject(ResourceFacade);

  screens = input<Screen[]>([]);

  displayedColumns: string[] = ['name', 'channel', 'mediaType', 'actions'];

  openEditDialog(screen: Screen): Observable<unknown> {
    const dialogRef = this._dialogService.open({
      component: ScreenCreationDialogComponent,
      fullscreen: true
    });

    dialogRef.componentRef?.setInput('screen', screen);

    return dialogRef.afterClosed();
  }

  openDeleteDialog(screen: Screen): void {
    const delete$ = this._screenService.remove(screen.id);

    const dialogRef = this._dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentInstance.removeObservable$ = delete$;
    dialogRef.componentRef?.setInput(
      'title',
      `Voulez-vous supprimer l'écran "${screen.name}" ?`
    );
    dialogRef
      .afterClosed()
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: () => {
            this._resourceFacade.getData({ refresh: true });
            this._snackbarService.open({
              text: 'Ecran supprimé avec succès',
              type: 'success'
            });
          }
        })
      )
      .subscribe();
  }
}
